// assets/tradein.js — Calcolo con somma danni (multi-difetto)
// Stima = Perfetto − Σ(Perfetto − Valore_con_quell’unico_difetto), minimo min_price.
// Nessuna "Condizione" (UI senza sezione condizione).

(function () {
  if (window.__TRADEIN_INIT__) return;
  window.__TRADEIN_INIT__ = true;

  const REDIRECT_URL = '/pages/ritiro';

  function ready(fn){ document.readyState==='loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  function findById(arr = [], id){ return (arr || []).find(x => String(x.id) === String(id)) || null; }

  ready(function () {
    const form        = document.getElementById('tradein-form');
    const modelSel    = document.getElementById('ti-model');
    const capacitySel = document.getElementById('ti-capacity');
    const priceEl     = document.getElementById('ti-price');
    const submitBtn   = document.getElementById('ti-submit');
    const feedback    = document.getElementById('ti-feedback');

    if (!form || !modelSel || !capacitySel || !priceEl || !submitBtn) {
      console.warn('[tradein] DOM incompleto'); 
      return;
    }

    const cfg = window.TRADEIN_CONFIG || {};
    const MIN_PRICE = Number(cfg.min_price) || 0;

    // Popola select
    modelSel.innerHTML = `<option value="" disabled selected>Seleziona</option>` +
      (cfg.models || []).map(m => `<option value="${m.id}">${m.label}</option>`).join('');

    capacitySel.innerHTML = `<option value="" disabled selected>Seleziona</option>` +
      (cfg.capacities || []).map(c => `<option value="${c.id}">${c.label}</option>`).join('');

    // Stato
    const state = { model: null, capacity: null, checks: {} };
    let lastPrice = null;

    // Messaggistica (con auto-hide support)
    function showMsg(msg = '', ok = true){
      if (!feedback) return;
      if (!msg) {
        feedback.hidden = true;
        feedback.textContent = '';
        feedback.classList.remove('--ok', '--err');
        return;
      }
      feedback.textContent = msg;
      feedback.hidden = false;
      feedback.classList.remove('--ok', '--err');
      feedback.classList.add(ok ? '--ok' : '--err');
    }
    function clearMessage(){ showMsg('', true); }

    function compute(){
      // Ogni ricalcolo pulisce eventuali messaggi precedenti
      clearMessage();

      const model = findById(cfg.models, state.model);
      const cap   = findById(cfg.capacities, state.capacity);

      if (!model || !cap) {
        priceEl.textContent = '—';
        submitBtn.disabled = true;
        lastPrice = null;
        return;
      }

      const key = `${model.id}:${cap.id}`;
      const row = (cfg.pricingTable || {})[key];
      if (!row || !row.perfect) {
        priceEl.textContent = '—';
        submitBtn.disabled = true;
        lastPrice = null;
        // Messaggio rivolto al cliente + UX: non resta appeso dopo nuove selezioni
        showMsg('Al momento non possiamo valutare questo modello. Prova a selezionarne un altro.', false);
        return;
      }

      const base = Number(row.perfect) || 0;

      // Difetti mappati 1:1 con i name dei checkbox
      const defectKeys = ['lcd_rotto','batteria_85_giu','retro_rotto','face_id_rotto','altro'];

      // Somma danni: per ogni difetto selezionato → danno = max(0, base − valore_colonna)
      let totalDamage = 0;
      for (const k of defectKeys) {
        if (state.checks[k]) {
          const v = Number(row[k]) || 0;
          const damage = Math.max(0, base - v);
          totalDamage += damage;
        }
      }

      let price = Math.max(MIN_PRICE, base - totalDamage);
      lastPrice = price;

      priceEl.textContent = price.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
      submitBtn.disabled = false;
    }

    // Eventi — e nascondi sempre il messaggio al cambio selezione
    modelSel.addEventListener('change', e => { state.model = e.target.value; clearMessage(); compute(); });
    capacitySel.addEventListener('change', e => { state.capacity = e.target.value; clearMessage(); compute(); });

    form.addEventListener('change', e => {
      if (e.target.type === 'checkbox') {
        state.checks[e.target.name] = e.target.checked;
        clearMessage();
        compute();
      }
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (lastPrice == null) { showMsg('Completa modello e capacità per proseguire.', false); return; }
      submitBtn.disabled = true;

      const modelLabel = modelSel.options[modelSel.selectedIndex]?.text || state.model;
      const capLabel   = capacitySel.options[capacitySel.selectedIndex]?.text || state.capacity;

      const now = new Date();
      const code = `GP-${now.toISOString().slice(0,10).replace(/-/g,'')}-${Math.floor(1000 + Math.random()*9000)}`;

      try {
        sessionStorage.setItem('tradein_summary', JSON.stringify({
          code,
          model: modelLabel,
          capacity: capLabel,
          defects: Object.keys(state.checks).filter(k => state.checks[k]),
          price_text: priceEl.textContent.trim(),
          price_num: lastPrice,
          ts: now.toISOString()
        }));
      } catch (_) {}

      window.location.href = REDIRECT_URL;
    });
  });
})();
